import { Menu } from '@headlessui/react';
import { classNames } from '@library/utils';

export interface ActionsMenuItemProps {
  disabled?: boolean;
  handleOnClick: () => void;
  name: string;
}

export const ActionsMenuItem = ({
  disabled = false,
  handleOnClick,
  name
}: ActionsMenuItemProps) => {
  const { Button, Item } = Menu;
  return (
    <Item>
      {({ active }) => (
        <Button
          className={classNames(
            'hover:bg-soFresh-120 text-soClean-100 disabled:bg-soFresh-150 relative max-w-[20rem] cursor-default select-none px-1 py-2 disabled:cursor-not-allowed',
            active ? 'bg-soFresh-140' : ''
          )}
          disabled={disabled}
          name={`ActionsMenuItemButton-${name}`}
          onClick={handleOnClick}
          type="button"
        >
          <span className="block truncate text-xs">{name}</span>
        </Button>
      )}
    </Item>
  );
};
